import { Component } from "react";
import ProductListItem from "components/block-elements/product-list-item/product-list-item";
import { extract, JetshopStore } from "@parksandresorts/core";
import styles from "./rich-product.module.less";

export default class RichProduct extends Component {
  constructor(props) {
    super(props);

    this._isMounted = false;

    this.jetshopId = extract(props, "productData.jetshopId");

    this.state = {
      price: undefined,
      previousPrice: undefined,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (!this.jetshopId) {
      return;
    }

    JetshopStore.getExtendedProduct(this.jetshopId).then((product) => {
      if (!this._isMounted) {
        return;
      }

      this.setState({
        price: product.price,
        previousPrice: product.previousPrice,
      });
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <ProductListItem
        id={"id-" + this.props.contentful_id}
        {...this.props}
        componentTheme={null}
        price={this.state.price}
        previousPrice={this.state.previousPrice}
        forceMobile={true}
        disableLabel={true}
        wrapperClassName={styles.noPaddingWrapper}
      />
    );
  }
}
